module.exports = __webpack_public_path__ + "static/media/BtnPrint.02045d5b.svg";